module.exports = __webpack_public_path__ + "cd6a0d968c9006463fec797b6d0a173b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_15.jpg
 ** module id = 597
 ** module chunks = 0
 **/